






















import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import {
  SVG_PLACEHOLDER_IMAGES,
  LOADSTATUS,
  loadStatusType
} from '@/common/constants'
import { IMAGE_VARIANT } from '@/common/const'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    src: {
      type: String,
      default: undefined
    },
    loadStatus: {
      type: String as () => loadStatusType,
      required: true
    },
    alt: {
      type: String,
      default: undefined
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.CATEGORY_HERO_IMAGE
    },
    isLoaded(): boolean {
      return this.loadStatus === LOADSTATUS.LOADED
    },
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.CATEGORY_MAIN
    }
  }
})
